module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fvi-01.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fvii-01.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fviii-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A Home Guard checks the identity card of a policeman c1940. Fears of Nazi ‘Fifth Columnist’ infiltrators in disguise meant that nobody’s identity was taken for granted and a challenge to produce your identity card by any civil or military official could not be refused.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33e56c6f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Fm01.vue
// module id = 72
// module chunks = 0